import ValidatedTextField from 'common-mui/components/ValidatedTextField';
import { STREET_REGEX } from 'common-constants/validation';
import { TextField } from '@mui/material';
import React from 'react';
import { useFormContext } from 'react-hook-form';

const InputAddressStreet = ({ prefill }) => {
  const { control } = useFormContext();
  return (
    <ValidatedTextField
      name="street"
      control={control}
      defaultValue={prefill}
      rules={{
        required: 'This field is required.',
        pattern: {
          value: STREET_REGEX,
          message: 'This address could not be verified. Please enter a valid address.',
        },
      }}
    >
      <TextField fullWidth label="Street" />
    </ValidatedTextField>
  );
};

export default InputAddressStreet;
